export default __webpack_public_path__ + "07f67ff3.jpg";